import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Select from '../dev/Select'

class Sort extends Component {
    state={
        channelSortCategory: '訂閱數',
        channelSortRule: 'descending',
        videoSortCategory: 'relevance',
        videoSortRule: 'descending',
    }
    changeSort = () => {
        // const sortArgs = this.state;
        const { channelSortCategory, channelSortRule, videoSortCategory, videoSortRule} = this.state
        const { setCurrentPage} = this.props
        // let sort = Object.entries(sortArgs)
        //     .map(pairs => {
        //         const [key, value] = pairs.map(encodeURIComponent);
        //         return `${key}=${value}`;
        //     })
        //     .join("&");
        // this.props.dispatch({
        //     type: condition === 'channelSortCategory' ? 'CHANGE_CHANNEL_SORT' : 'CHANGE_VIDEO_SORT',
        //     sort: sort,
        //     [condition]: this.state[condition]
        // })
        this.props.dispatch({
            type: 'CHANGE_SORT',
            channelSortCategory: channelSortCategory,
            channelSortRule: channelSortRule,
            videoSortCategory: videoSortCategory,
            videoSortRule: videoSortRule,
        })
        setCurrentPage(1)
    }
    sortCategorySelect = (condition) => ({ value = '' }) => this.setState({ [condition]: value },() => this.changeSort(condition))
    sortRuleSelect = (condition) => ({ value = '' }) => this.setState({ [condition]: value }, () => this.changeSort())
    render() {
        const { length, total, isChannelTags, currentPage, messages, infolist: { channelKeyword, videoKeyword} } = this.props
        const { state: { channelSortCategory, videoSortCategory, channelSortRule, videoSortRule }, sortCategorySelect, sortRuleSelect } = this
        const sortCategoryType = [
            { value: '訂閱數', label: messages.subscribers},
            { value: '月訂閱數', label: messages.monthly_subscribers},
            { value: '月訂閱成長率', label: messages.monthly_subscriptions_growth,},
            { value: '月觀看數', label: messages.monthly_views,},
            { value: '月觀看成長率', label: messages.monthly_views_growth},
            { value: '近20支平均觀看數', label: messages['20_avg_views']},
            { value: '近20支平均互動率', label: messages['20_avg_engage']}]
        const sortCategoryType2 = [ //PM 加一下影片排序
            { value: 'relevance', label: messages.info_list_sort_relevance},
            { value: 'subscriberCount', label: messages.subscribers},
            { value: 'viewCount', label: messages.info_list_video_views,},
            { value: 'engageRate', label: messages.info_list_video_engage}]  
        const sortRuleType = [
            { value: 'descending', label: messages.info_list_sort_high},
            { value: 'ascending', label: messages.info_list_sort_low},
        ]
        return (
            <Container>
                <KeywordResultWrap>
                    {channelKeyword !== "" && isChannelTags && <div id="ga_channellist_keyword">{messages.info_list_search_for} "{channelKeyword}"</div> }
                    {videoKeyword !== "" && !isChannelTags && <div id="ga_videolist_keyword">{messages.info_list_search_for} "{videoKeyword}"</div>}
                    show {length === 0 ? 0 : currentPage * 25 - 24} to {length < 25 ? total : (currentPage * 25)} of {total}
                </KeywordResultWrap>
                {isChannelTags && 
                    <SortWrap>
                        {messages.info_list_sort}：
                        <SelectWrap>
                            <Select
                                value={channelSortCategory}
                                onChange={sortCategorySelect('channelSortCategory')}
                                options={sortCategoryType}
                                placeholder={sortCategoryType.find(i => i.value === channelSortCategory).label}
                                id='sort'
                                isSearchable={false}
                                margin='0 8px 0 0'
                            />
                            <Select
                                value={channelSortRule}
                                onChange={sortRuleSelect('channelSortRule')}
                                options={sortRuleType}
                                placeholder={sortRuleType.find(i => i.value === channelSortRule).label}
                                id='sort'
                                isSearchable={false}
                            />
                        </SelectWrap>
                    </SortWrap>}
                {!isChannelTags &&  //PM 加一下影片排序
                    <SortWrap>
                        {messages.info_list_sort}：
                        <SelectWrap>
                            <Select
                                value={videoSortCategory}
                                onChange={sortCategorySelect('videoSortCategory')}
                                options={sortCategoryType2}
                                placeholder={sortCategoryType2.find(i => i.value === videoSortCategory).label}
                                id='sort'
                                isSearchable={false}
                                margin='0 8px 0 0'
                            />
                            {videoSortCategory !== 'relevance' && // PM把用關聯性排序時的 rule 隱藏 但如果先在頻道檢索切換過sortCategory 換到影片檢索時還是會跑出來 解法可能 toggle 就要把 sortcategory 清空?
                                <Select
                                    value={videoSortRule}
                                    onChange={sortRuleSelect('videoSortRule')}
                                    options={sortRuleType}
                                    placeholder={sortRuleType.find(i => i.value === videoSortRule).label}
                                    id='sort'
                                    isSearchable={false}                                    
                                />}
                        </SelectWrap>
                        
                    </SortWrap>}
            </Container>
        )
    }
}
const mapStateToProps = state => {
    return {
        infolist: state.InfoList,
        messages: state.Messages
    }
}
export default connect(mapStateToProps)(Sort);
const Container = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 900px;
    padding: 20px 0;
    font-size: 10px;
    font-weight: 500;
    color: #999999;
    @media (max-width: 665px){
        width: calc(100% - 40px);
        flex-direction: column;
        padding-left: 10px;
    }    
`
const SortWrap = styled.div`
    display: flex;
    align-items: center;
    @media (max-width: 665px){
        flex-direction: column;
        align-items: initial;
        justify-content: center;
    } 
`
const SelectWrap = styled.div`
    display: flex;
    align-items: center;
`
const KeywordResultWrap = styled.div`
    display: flex;
    div {
        margin-right: 5px;
    }
`


// WEBPACK FOOTER //
// ./src/InfoList/Sort.js